export enum OptionsTypeList {
  TAG = 'TAG',
  MEMBER = 'MEMBER',
  REWARD = 'REWARD',
  PROMOTION = 'PROMOTION',
  SPONSORSHIP = 'SPONSORSHIP',
  WHEEL_GAME = "WHEEL_GAME",
}
